module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/212.c9677b95.png";